import {gtmEvent, loggedOutSegment, segment} from './helpers'
import {EventTypeNames, Madlibs} from '../store/enum'

export const clickedMadlibsGetStarted = (event) =>
  loggedOutSegment('Clicked Madlibs Get Started', {
    event: {
      ...event,
      ...{
        type: EventTypeNames[event.type],
      },
    },
  })

export const selectedMadlibsOption = (id, value, context) =>
  loggedOutSegment('Selected Madlibs Option', {
    context,
    id,
    value: id === Madlibs.eventType ? EventTypeNames[value] : value,
  })

export const onboardingOpened = () => {
  loggedOutSegment('Opened Onboarding')
  gtmEvent('onboardingOpen')
}

export const onboardingClosed = (step) => {
  loggedOutSegment('Closed Onboarding', {exitStep: step})
  gtmEvent('onboardingClose', {step})
}

export const onboardingLoggedIn = (email) => {
  gtmEvent('onboardingLogin', {email})
}

export const onboardingRegistered = (email) => {
  segment('Submitted Signup Information')
  gtmEvent('onboardingSignup', {email})
}

// TODO: GROWTH-927 decide whether to add.
// export const onboardingPasswordReset = (email) => {
//   segment('Reset Password via Onboarding', {email})
//   gtmEvent('onboardingPasswordReset', {email})
// }

export const onboardingEventTypeSubmitted = (type) => {
  segment('Submit Onboarding Event Type', {type: EventTypeNames[type]})
  gtmEvent('onboardingEventType', {type: EventTypeNames[type]})
}

// date format must be: 'YYYY-MM-DD' for iterable
export const onboardingEventDateSubmitted = (date) => {
  segment('Submit Onboarding Event Date', {date: `${date} 00:00:00 +00:00`})
  gtmEvent('onboardingEventDate', {date})
}

export const onboardingRoleSubmitted = (role) => {
  segment('Submit Onboarding Role', {role})
  gtmEvent('onboardingCustomerData', {role})
}

export const onboardingParticipantNumberSubmitted = (count) => {
  segment('Submit Onboarding Number of Participants', {number_of_participants: count})
  gtmEvent('onboardingNumberParticipants', {count})
}

export const onboardingSummaryCtaClicked = () => {
  segment('Onboarding Summary CTA')
  gtmEvent('onboardingSummary')
}

export const onboardingAttributionSurveySubmitted = (answer) => {
  segment('Submit Onboarding Attribution Survey', {answer})
  gtmEvent('onboardingAttributionSurvey', {answer})
}
